const degrees = [
  {
    school: 'Anna University',
    degree: 'B.E. Electronics and Communication Engineering',
    link: 'https://annauniv.edu',
    year: 2024,
  },
];

export default degrees;
